export const rows = [10, 25, 50, 100];
